const rankingItems = [
  { rank: 1, title: '流浪地球3', type: '电影', hot: '🔥 985万热度', tag: '科幻巨制' },
  { rank: 2, title: '长安十二时辰', type: '电视剧', hot: '🔥 872万热度', tag: '古装悬疑' },
  { rank: 3, title: '哪吒之天劫降临', type: '电影', hot: '🔥 856万热度', tag: '国漫巅峰' },
  { rank: 4, title: '狂飙：风云再起', type: '电视剧', hot: '🔥 743万热度', tag: '刑侦大剧' },
  { rank: 5, title: '深海迷航', type: '电影', hot: '🔥 698万热度', tag: '冒险奇幻' },
  { rank: 6, title: '披荆斩棘4', type: '综艺', hot: '🔥 621万热度', tag: '热门综艺' },
  { rank: 7, title: '边境风云', type: '电影', hot: '🔥 587万热度', tag: '动作犯罪' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              热度榜单
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              糖心影视平台实时热度排名，发现当下最受欢迎的影视内容
            </p>
          </div>
          <div className="flex items-center gap-2">
            <span className="px-4 py-1.5 text-xs font-medium bg-primary-500 text-background-50 rounded-full whitespace-nowrap">综合热度</span>
            <span className="px-4 py-1.5 text-xs font-medium text-foreground-500 bg-background-100 rounded-full whitespace-nowrap">本周新片</span>
            <span className="px-4 py-1.5 text-xs font-medium text-foreground-500 bg-background-100 rounded-full whitespace-nowrap">经典重温</span>
          </div>
        </div>

        <div className="space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 md:gap-6 p-4 md:p-5 rounded-xl bg-background-100 hover:bg-primary-50/50 transition-all cursor-pointer group border border-transparent hover:border-primary-200/40"
            >
              <span className={`w-9 h-9 flex items-center justify-center rounded-lg font-heading text-lg font-bold flex-shrink-0 ${
                item.rank === 1 ? 'bg-accent-500 text-background-50' :
                item.rank === 2 ? 'bg-foreground-300 text-background-50' :
                item.rank === 3 ? 'bg-primary-400 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-3 flex-wrap">
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 text-[10px] font-medium bg-primary-100 text-primary-700 rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <span className="text-xs text-foreground-400 whitespace-nowrap hidden sm:block">{item.type}</span>
              <span className="text-xs font-medium text-accent-600 whitespace-nowrap">{item.hot}</span>
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all flex-shrink-0">
                <i className="ri-play-fill text-sm"></i>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}